import { PageHeader } from "components/ui";
import React, { useState } from "react";
import { Grid, Typography, Box } from "@mui/material";
import CustomButton from "../../components/buttonsComponent/StyledButton";
import DownloadZipButton from "components/buttonsComponent/DownloadZipButton";
import { fontFamily, fontSize } from "../../../node_modules/@mui/system/index";
import { Outlet } from "react-router-dom";
import NavigationButtons from "helper/navigation/NavigationButtons";
import GriEmpowerment from "../../assets/images/GriEmpowerment.png";

const ReferanceSources = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [prevStep, setPrevStep] = useState(0);

  const handleBack = () => {
    setPrevStep(activeStep);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  // Configuration objects for each reference source
  const referenceConfigs = {
    icma: [
      {
        config: {
          name: "GBP-ICMA.pdf",
        },
        title: "🔗 Green Bond Principles (GBP) - ICMA",
        externalHref: "https://www.icmagroup.org/sustainable-finance",
      },
      {
        config: {
          name: "SBP-ICMA.pdf",
        },
        title: "🔗 Social Bond Principles (SBP) - ICMA",
        externalHref:
          "https://www.icmagroup.org/sustainable-finance/social-bond-principles",
      },
      {
        config: {
          name: "SBG-ICMA.pdf",
        },
        title: "🔗 Sustainability Bond Guidelines (SBG) - ICMA",
        externalHref:
          "https://www.icmagroup.org/sustainable-finance/sustainability-bond-guidelines-sbg",
      },
      {
        config: {
          name: "SLBP-ICMA.pdf",
        },
        title: "🔗 Sustainability-Linked Bond Principles (SLBP) - ICMA",
        externalHref:
          "https://www.icmagroup.org/sustainable-finance/sustainability-linked-bond-principles-slbp",
      },
    ],
    climate: [
      {
        config: {
          name: "CBI-Main.pdf",
        },
        title: "🔗 Climate Bonds Initiative (CBI) - Main Portal",
        externalHref: "https://www.climatebonds.net",
      },
      {
        config: {
          name: "CBI-Taxonomy.pdf",
        },
        title: "📄 CBI Taxonomy & Certification Standards",
        externalHref: "https://www.climatebonds.net/standard/taxonomy",
      },
    ],
    loans: [
      {
        config: {
          name: "GLP-LSTA.pdf",
        },
        title: "🔗 Green Loan Principles (GLP) - LSTA",
        externalHref: "https://www.lsta.org/content/green-loan-principles",
      },
      {
        config: {
          name: "SLP-LSTA.pdf",
        },
        title: "🔗 Social Loan Principles (SLP) - LSTA",
        externalHref: "https://www.lsta.org/content/social-loan-principles",
      },
      {
        config: {
          name: "SLLP-LSTA.pdf",
        },
        title: "🔗 Sustainability-Linked Loan Principles (SLLP) - LSTA",
        externalHref:
          "https://www.lsta.org/content/sustainability-linked-loan-principles-sllp",
      },
    ],
    apac: [
      {
        config: {
          name: "Singapore-Green-Bond-Framework.pdf",
        },
        title: "🔗 Singapore Green Bond Framework - Ministry of Finance Singapore",
        externalHref:
          "https://www.mof.gov.sg/singaporegreenbonds",
      },
      {
        config: {
          name: "Malaysia-SRI-Sukuk-Framework.pdf",
        },
        title: "🔗 Malaysia Sustainable and Responsible Investment (SRI) Sukuk Framework",
        externalHref: "https://www.sc.com.my/development/sri",
      },
      {
        config: {
          name: "ASEAN-Green-Bond-Standards.pdf",
        },
        title: "🔗 ASEAN Green, Social and Sustainability Bond Standards",
        externalHref: "https://www.theacmf.org/initiatives/sustainable-finance",
      },
      {
        config: {
          name: "Philippines-Sustainable-Finance-Framework.pdf",
        },
        title: "🔗 Philippines Sustainable Finance Roadmap & Green Bonds",
        externalHref: "https://www.bwt.gov.ph",
      },
    ],
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <PageHeader title="AI-Powered ESG Reporting across Global, National, Sectoral, and Industry-Specific Standards" />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box className="gri-header">
          <NavigationButtons
            imageKey="dashboardImg2_3"
            title="Sustainable Finance & Bond Standards"
            activeStep={activeStep}
            onBack={handleBack}
          />
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          sx={{
            borderRadius: "8px",
            padding: "24px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              className="mb-4"
              variant="h6"
              style={{
                fontWeight: 700,
                color: "#02462E",
                mb: 3,
                fontSize: "40px",
                fontFamily: "DM Sans",
                lineHeight: "38px",
                letterSpacing: "-2%",
              }}
            >
              The global standards for Environmental <br />
              sustainability.{" "}
            </Typography>

            <Box sx={{ mt: 4 }}>
              {/* ICMA Standards Section */}
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, mb: 3, color: "#02462E" }}
              >
                International Capital Market Association (ICMA)
              </Typography>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 4 }}
              >
                {referenceConfigs.icma.map((item, index) => (
                  <DownloadZipButton
                    key={index}
                    config={item.config}
                    title={item.title}
                    externalHref={item.externalHref}
                  />
                ))}
              </Box>

              {/* Climate Bonds Initiative Section */}
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, mb: 3, color: "#02462E" }}
              >
                Climate Bonds Initiative
              </Typography>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 4 }}
              >
                {referenceConfigs.climate.map((item, index) => (
                  <DownloadZipButton
                    key={index}
                    config={item.config}
                    title={item.title}
                    externalHref={item.externalHref}
                  />
                ))}
              </Box>

              {/* Loan Market Association Standards */}
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, mb: 3, color: "#02462E" }}
              >
                Loan Market Association Standards (LSTA, APLMA, LMA)
              </Typography>
              <Box
                sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 4 }}
              >
                {referenceConfigs.loans.map((item, index) => (
                  <DownloadZipButton
                    key={index}
                    config={item.config}
                    title={item.title}
                    externalHref={item.externalHref}
                  />
                ))}
              </Box>

              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  mb: 3,
                  color: "#02462E",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                🌏 APAC & ASEAN Green Finance Frameworks (Singapore, Malaysia, Indonesia, Vietnam, Thailand, Philippines)
              </Typography>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {referenceConfigs.apac.map((item, index) => (
                  <DownloadZipButton
                    key={index}
                    config={item.config}
                    title={item.title}
                    externalHref={item.externalHref}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ReferanceSources;
